import React from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import {includes} from 'lodash'

// components
import Layout from "./Layout";

// pages
import Error from '../pages/error'
import Login from '../pages/login'
import ResetPassowrd from '../pages/resetPassword'
import SignupSuccess from '../pages/signup/SignupSuccess'
import Verify from '../pages/verify/Verify'

import axios from 'axios'
import { get } from 'lodash'
// context
import { useUserState } from "../context/UserContext";
import { signOut, useUserDispatch } from '../context/UserContext'
import { setLoading, useLoadDispatch } from '../context/LoadingContext'

export default function App() {
	const { isAuthenticated, user } = useUserState()

	const loader = useLoadDispatch()

	axios.defaults.baseURL = get(process.env, 'REACT_APP_APIURL', '')
	axios.defaults.headers.post['Content-Type'] = 'application/json'
	const authToken = localStorage.getItem('auth_token')
	const isHandlerEnabled = (config = {}) => {
		return config.hasOwnProperty('handlerEnabled') && !config.handlerEnabled ?
		false : true
	}

	const errorHandler = (error) => {
		if (isHandlerEnabled(error.config)) {
			if(error.response.status === 401){
				console.log('Error', error.response.status)
				signOut(useUserDispatch, null)
			}
		}
		return Promise.reject({ ...error })
	}

	const successHandler = (response) => {
		if (isHandlerEnabled(response.config)) {
		}
		return response
	}

	axios.interceptors.request.use(
		request => {
			setLoading(loader, true)
			return request
		},
		error => {
			setLoading(loader, true)
			return error
		}
	)

	axios.interceptors.response.use(
		response => {
			setLoading(loader, false)
			return successHandler(response)
		},
		error => {
			setLoading(loader, false)
			return errorHandler(error)
		}
	)

	if (authToken) {
		axios.defaults.headers.common[
			'Authorization'
		] = `Bearer ${localStorage.getItem('auth_token')}`
	}

	let defaultRouteUrl = '/app/employees'
	if(isAuthenticated && user) {
		if(includes(user.roles, 'client_group') || includes(user.roles, 'finance')){
			defaultRouteUrl = '/app/reports'
		}
	}

	return (
		<BrowserRouter>
			<Switch>
				<Route exact path="/" render={() => <Redirect to={defaultRouteUrl} />} />
				<Route
					exact
					path="/app"
					render={() => <Redirect to={defaultRouteUrl} />}
				/>
				<PrivateRoute path="/app" component={Layout} />
				<PublicRoute path="/login" component={Login} />
				<PublicRoute path='/resetpassword' component={ResetPassowrd} />
				<PublicRoute path="/signup/success" component={SignupSuccess} />
				<PublicRoute path="/verify" component={Verify} />
				<Route component={Error} />
			</Switch>
		</BrowserRouter>
	);

	function PrivateRoute({ component, ...rest }) {
		return (
			<Route
				{...rest}
				render={props =>
					isAuthenticated ? (
						React.createElement(component, props)
					) : (
							<Redirect
								to={{
									pathname: "/login",
									state: {
										from: props.location,
									},
								}}
							/>
						)
				}
			/>
		);
	}

	function PublicRoute({ component, ...rest }) {
		return (
			<Route
				{...rest}
				render={props =>
					isAuthenticated ? (
						<Redirect
							to={{
								pathname: "/",
							}}
						/>
					) : (
							React.createElement(component, props)
						)
				}
			/>
		);
	}
}
